import {
  BREAKPOINT_MEDIUM,
  BREAKPOINT_MEDIUM_LARGE,
  BREAKPOINT_SMALL,
  Z_INDEX,
} from '@big-red-group/storefront-common-ui'
import Link from 'next/link'
import styled from 'styled-components'

export const Main = styled.div`
  display: grid;
  grid-template-columns: 140px 1fr;
  grid-gap: 64px;
  margin-bottom: 64px;
  position: relative;
  z-index: ${Z_INDEX.medium};

  @media (max-width: ${BREAKPOINT_MEDIUM_LARGE}px) {
    grid-template-columns: 1fr;
  }
`
export const Secondary = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
  font-size: 12px;
  font-weight: var(--font-light);

  & span:first-child {
    margin-right: 32px;
  }

  & a {
    color: var(--text-inverse);
    text-decoration: none;
  }

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    flex-direction: column;
    align-items: flex-start;

    & > svg {
      margin-top: 48px;
    }
  }
`
export const BottomWrapper = styled.div`
  background-color: #242424;
  padding: 35px 104px;
  color: var(--text-inverse);

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    padding: 40px 25px;
  }
`
export const Third = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;

  svg {
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`
export const FooterBottomText = styled.p`
  font-weight: var(--font-regular);
  font-size: 14px;
  line-height: 1.6;
  color: var(--text-inverse);
`
export const SmallLinks = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
  font-size: 12px;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;
  }
`
export const Social = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 20px;

  a {
    display: block;
  }

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
`
export const Menu = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 25%));
  align-items: flex-start;
  grid-gap: 32px;

  @media (max-width: 1000px) {
    grid-template-columns: minmax(0, 50%) minmax(0, 50%);
    grid-gap: 64px;
  }
  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`
export const SectionTitle = styled.h3`
  font-size: 18px;
`
export const SectionLink = styled(Link)`
  font-size: 14px;
  font-weight: var(--font-light);
  line-height: 1.1;
  margin-top: 32px;
  display: block;
  color: var(--text-inverse);
  text-decoration: none;
  width: fit-content;
`

export const SignupCta = styled.div`
  margin-top: 60px;
  width: 165px;
  position: relative;
  cursor: pointer;

  svg {
    width: 100%;
  }

  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: var(--font-bold);
    font-size: 14px;
    color: var(--brand-secondary);
    width: 80%;
    line-height: 1.4;
    text-align: center;
  }

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    margin-top: 20px;
    width: 100%;

    svg {
      width: 166px;
    }

    span {
      width: 136px;
      left: 15px;
      transform: translateY(-50%);
    }
  }
`

export const MainWrapper = styled.footer<{ lightFooter?: boolean }>`
  background-color: var(--bg-black);
  padding: 64px 104px 32px 104px;
  color: --var(--text-inverse);
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  margin-top: -30px;
  z-index: ${Z_INDEX.footer};
  position: relative;

  ${({ lightFooter }) =>
    lightFooter &&
    `
      color: black;
      background-color: #E1E1E1;
      
      ${SectionLink},
      ${Secondary} a {
        color: black;
      }
    `}

  @media (max-width: 768px) {
    padding: 64px 25px 32px 25px;
  }
`

export const LogoContainer = styled.div`
  width: 100%;
  position: relative;
`
export const Mistletoe = styled.div`
  position: absolute;
  width: 60px;
  height: 60px;
  bottom: calc(100% + 4px);
  left: 70px;
  transform: translateX(-50%);
  z-index: ${Z_INDEX.base};
`

export const PaymentMethods = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  pointer-events: none;
  margin-left: 32px;

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    margin: 0;
  }
`
export const CardIcon = styled.div`
  border: 1px solid var(--grey-100);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 30px;
  flex-shrink: 0;

  svg {
    width: 80%;
    height: 60%;
  }
`
